import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=b3936f10&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=b3936f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3936f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3936f10')) {
      api.createRecord('b3936f10', component.options)
    } else {
      api.reload('b3936f10', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=b3936f10&scoped=true&", function () {
      api.rerender('b3936f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-258xmjW425xN6/JS/comp/DocBox.vue"
export default component.exports